import {observer} from "mobx-react-lite";
import {Button, Col, InputGroup, UncontrolledTooltip} from "reactstrap";
import React, {useContext} from "react";
import {FormattedMessage} from "react-intl";
import {StateContext} from "../../../../App";
import {useRouterStore} from "mobx-state-router";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExport} from "@fortawesome/free-solid-svg-icons";

const ExportButton = observer(({viewState}) => {
  const stateContext = useContext(StateContext);
  const routerStore = useRouterStore();

  return stateContext?.appConfigs?.features?.cmp_ui_data_exports?.enabled && (
    <>
      <Col sm={0.5}>
        <div></div>
      </Col>
      <Col sm={0.5} className="reset-button-col">
        <InputGroup>
          <Button id="create-data-export-button" color="primary" onClick={() => viewState?.handleExportClick(routerStore)}>
            <FontAwesomeIcon icon={faFileExport} />
          </Button>
        </InputGroup>
      </Col>
      <UncontrolledTooltip target="create-data-export-button" placement="top">
        <FormattedMessage id="createQr.exportBtn.defaultMessage"/>
      </UncontrolledTooltip>
    </>
  );
});

export default ExportButton;
